import React from 'react';
import clsx from 'clsx';
import { CountryFlag } from "../base";
import { countriesI18nExpanded } from "./countries-i18n-expanded";
import { CountryType } from "./countries-i18n-expanded.vm";
import "./country-flag-expanded.style.scss";
export const CountryFlagExpanded = props => {
  const {
    alpha2,
    style,
    className
  } = props;
  const type = React.useMemo(() => {
    return countriesI18nExpanded.getCountryType(alpha2);
  }, [alpha2]);
  switch (type) {
    case CountryType.OFFICIALLY_ASSIGNED:
      return /*#__PURE__*/React.createElement(CountryFlag, {
        alpha2: alpha2,
        style: style,
        className: className
      });
    case CountryType.TRANSITIONALLY_RESERVED:
      return /*#__PURE__*/React.createElement("div", {
        className: clsx('flag-transitionally-reserved', className),
        style: style
      }, /*#__PURE__*/React.createElement("div", {
        className: "flag-label"
      }, "TR"));
    case CountryType.EXCEPTIONALLY_RESERVED:
      return /*#__PURE__*/React.createElement("div", {
        className: clsx('flag-exceptionally-reserved', className),
        style: style
      }, /*#__PURE__*/React.createElement("div", {
        className: "flag-label"
      }, "ER"));
    default:
      return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
};